import {
  createContext,
  type FC,
  type PropsWithChildren,
  useContext,
  useMemo,
} from 'react'

import { type useDirectContactFormSubjectLoginModal } from '../../hooks/useDirectContactFormSubjectLoginModal'

type SubjectLoginModal = ReturnType<
  typeof useDirectContactFormSubjectLoginModal
>

type DirectContactFormHookFormDialogAuthentication = {
  handleLoginModalClose: SubjectLoginModal['handleLoginModalClose']
  handleLoginSuccess: SubjectLoginModal['handleLoginSuccess']
  isCustomerDataComplete: boolean
  isLoggedIn: boolean
  isLoginModalOpen: boolean
}

const DirectContactFormHookFormDialogAuthenticationContext =
  createContext<DirectContactFormHookFormDialogAuthentication | null>(null)

export const DirectContactFormHookFormDialogAuthenticationProvider: FC<
  PropsWithChildren<DirectContactFormHookFormDialogAuthentication>
> = ({
  children,
  handleLoginModalClose,
  handleLoginSuccess,
  isCustomerDataComplete,
  isLoggedIn,
  isLoginModalOpen,
}) => {
  const value = useMemo(
    () => ({
      handleLoginModalClose,
      handleLoginSuccess,
      isCustomerDataComplete,
      isLoggedIn,
      isLoginModalOpen,
    }),
    [
      handleLoginModalClose,
      handleLoginSuccess,
      isCustomerDataComplete,
      isLoggedIn,
      isLoginModalOpen,
    ],
  )

  return (
    <DirectContactFormHookFormDialogAuthenticationContext.Provider
      value={value}
    >
      {children}
    </DirectContactFormHookFormDialogAuthenticationContext.Provider>
  )
}

export const useDirectContactFormHookFormDialogAuthentication =
  (): DirectContactFormHookFormDialogAuthentication => {
    const context = useContext(
      DirectContactFormHookFormDialogAuthenticationContext,
    )

    if (context === null) {
      throw new Error(
        'DirectContactFormHookFormDialogAuthenticationProvider missing',
      )
    }

    return context
  }
